import React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {useSelector} from 'react-redux'
import {GetReportId, GetSingleMessageData} from '../reportSlices/reportAnalytics'
import {CircularProgressbar, buildStyles} from 'react-circular-progressbar'
import ReactApexChart from 'react-apexcharts'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import moment from 'moment-timezone'
import {isEmpty} from '../../../../Utils/_helpers'
import VCardPreview from '../../../../Components/VCardPreview'
import {getIsDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'

const Snapshot = () => {
  const navigate = useNavigate()
  const messageData = useSelector(GetSingleMessageData)
  const reportData = useSelector(GetReportId)
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  let bouncedPer = messageData?.recipients
    ? (+messageData?.bouncedMessage * 100) / +messageData?.recipients
    : 0

  const NosendData = messageData?.recipients
    ? ((+messageData?.recipients - +messageData?.deliveredMessage - +messageData?.bouncedMessage) *
        100) /
      +messageData?.recipients
    : 0

  let sendData = messageData?.recipients
    ? (+messageData?.deliveredMessage * 100) / +messageData?.recipients
    : 0

  let deliveredData =
    messageData?.deliveredMessage > messageData?.recipients
      ? messageData?.recipients
      : messageData?.deliveredMessage

  if (messageData?.staggerId && messageData?.totalRecipients) {
    sendData = messageData?.totalRecipients
      ? (+deliveredData * 100) / +messageData?.totalRecipients
      : 0
  }

  const totalClickThrough = () => {
    let totalNumb = messageData?.recipients

    if (!isDefaultRegion) {
      const messageData = reportData?.data

      if (messageData?.tracking_links?.length > 0) {
        return messageData?.tracking_links?.length * messageData?.total_recipient
      }
      return messageData?.total_recipient
    }

    if (messageData?.tracking_links?.length > 0) {
      totalNumb = messageData?.recipients * messageData?.tracking_links?.length
    }

    if (messageData?.landingPage && messageData?.tracking_links?.length > 0) {
      totalNumb += messageData?.recipients
    }

    return totalNumb
  }

  const bouncedData: any = {
    series: [bouncedPer, sendData, NosendData],

    options: {
      chart: {
        type: 'donut',
      },
      // fill: {
      //   colors: ['#EEF6FF', '#3E97FF'],
      // },
      labels: [
        `Failed      ${messageData?.bouncedMessage} (${+bouncedPer?.toFixed(2)}%)`,
        `Delivered      ${+deliveredData} (${+sendData?.toFixed(2)}%)`,
        `Not sent  ${
          +messageData?.recipients - +messageData?.bouncedMessage - +messageData?.deliveredMessage
        } (${+(100 - sendData)?.toFixed(2)}%)`,
      ],
      legend: {
        show: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  }

  let bouncedPerRegion = reportData?.data?.total_recipient
    ? (+reportData?.data?.fail_message_count * 100) / +reportData?.data?.total_recipient
    : 0

  const NosendDataRegion = reportData?.data?.total_recipient
    ? ((+reportData?.data?.total_recipient -
        +reportData?.data?.delivered_message_count -
        +reportData?.data?.fail_message_count) *
        100) /
      +reportData?.data?.total_recipient
    : 0

  let sendDataRegion = reportData?.data?.total_recipient
    ? (+reportData?.data?.delivered_message_count * 100) / +reportData?.data?.total_recipient
    : 0

  const bouncedDataRegion: any = {
    series: [bouncedPerRegion, sendDataRegion, NosendDataRegion],

    options: {
      chart: {
        type: 'donut',
      },
      // fill: {
      //   colors: ['#EEF6FF', '#3E97FF'],
      // },
      labels: [
        `Failed      ${reportData?.data?.fail_message_count} (${+bouncedPer?.toFixed(2)}%)`,
        `Delivered      ${+reportData?.data
          ?.delivered_message_count} (${+reportData?.data?.delivered_message_count?.toFixed(2)}%)`,
        `Not sent  ${
          +reportData?.data?.total_recipient -
          +reportData?.data?.fail_message_count -
          +reportData?.data?.delivered_message_count
        } (${+(100 - sendDataRegion)?.toFixed(2)}%)`,
      ],
      legend: {
        show: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  }

  const calculateResult = (firstNumber: number = 0, secondNumber: number = 0) =>
    Math.round((100 * secondNumber) / firstNumber) ?? 0

  const getColor = (value: number = 0) =>
    value < 25 ? '#F53B6E' : value < 70 ? '#FCC419 ' : ' #12B886'

  const getUnsubscribeCount = (bmData: any) => {
    let unsubscribeCount = 0
    if (bmData?.replyStopToOptOut === true && bmData?.gatewaymessagesreplyStop) {
      unsubscribeCount = bmData?.gatewaymessagesreplyStop
    } else if (bmData?.unsub) {
      unsubscribeCount = bmData?.unsub
    }

    return unsubscribeCount
  }

  const renderRegionData = () => {
    const messageData = reportData?.data

    return (
      <>
        <>
          <div className='counted_box_wrapper row'>
            <div className='col-xl-2 col-md-3 col-sm-4 col-6 '>
              <div
                className='counted_box circle-progress'
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => navigate('/eofy/contacts')}
                data-testid='bmReportChartContacts'
              >
                <div
                  className='box'
                  style={{
                    gap: '0px',
                    marginTop: '10px',
                  }}
                >
                  <div style={{width: 100, height: 100}}>
                    <CircularProgressbar
                      value={calculateResult(
                        messageData?.staggerId && messageData?.totalRecipients
                          ? messageData?.totalRecipients
                          : messageData?.total_recipient,
                        messageData?.total_recipient
                      )}
                      text={`${calculateResult(
                        messageData?.staggerId && messageData?.totalRecipients
                          ? messageData?.totalRecipients
                          : messageData?.total_recipient,
                        messageData?.total_recipient
                      )}%`}
                      styles={buildStyles({
                        textColor: '#3F4254',
                        pathColor: getColor(
                          calculateResult(
                            messageData?.staggerId && messageData?.totalRecipients
                              ? messageData?.totalRecipients
                              : messageData?.total_recipient,
                            messageData?.total_recipient
                          )
                        ),
                        trailColor: '#EEF6FF',
                      })}
                    />
                  </div>

                  <div
                    className='title'
                    style={{
                      whiteSpace: 'nowrap',
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                      marginTop: '12px',
                    }}
                  >
                    Contacts
                    <div className='bottom'>
                      <div className='left'>
                        (
                        {messageData?.staggerId && messageData?.completedRecipients
                          ? `${messageData?.completedRecipients}/${messageData?.totalRecipients}`
                          : messageData?.total_recipient}
                        )
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
              <div
                className='counted_box circle-progress'
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => navigate('/eofy/contacts')}
                data-testid='bmReportChartDelivered'
              >
                <div
                  className='box'
                  style={{
                    gap: '0px',
                    marginTop: '10px',
                  }}
                >
                  <div style={{width: 100, height: 100}}>
                    <CircularProgressbar
                      value={calculateResult(
                        messageData?.staggerId && messageData?.totalRecipients
                          ? messageData?.totalRecipients
                          : messageData?.total_recipient,
                        messageData?.delivered_message_count
                      )}
                      text={`${calculateResult(
                        messageData?.staggerId && messageData?.totalRecipients
                          ? messageData?.totalRecipients
                          : messageData?.total_recipient,
                        messageData?.delivered_message_count
                      )}%`}
                      styles={buildStyles({
                        textColor: '#3F4254',
                        pathColor: getColor(
                          calculateResult(
                            messageData?.staggerId && messageData?.totalRecipients
                              ? messageData?.totalRecipients
                              : messageData?.recipients,
                            messageData?.delivered_message_count
                          )
                        ),
                        trailColor: '#EEF6FF',
                      })}
                    />
                  </div>
                  <OverlayTrigger
                    placement='bottom'
                    overlay={<Tooltip>Message delivered to customers mobile</Tooltip>}
                  >
                    <div
                      className='title'
                      style={{
                        whiteSpace: 'nowrap',
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        marginTop: '12px',
                      }}
                    >
                      Delivered
                      <div className='bottom'>
                        <div className='left'>({messageData?.delivered_message_count})</div>
                      </div>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
            <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
              <div
                className='counted_box circle-progress'
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => navigate('/eofy/bounced')}
                data-testid='bmReportChartFailed'
              >
                <div
                  className='box'
                  style={{
                    gap: '0px',
                    marginTop: '10px',
                  }}
                >
                  <div style={{width: 100, height: 100}}>
                    <CircularProgressbar
                      value={calculateResult(
                        messageData?.total_recipient,
                        messageData?.fail_message_count
                      )}
                      text={`${calculateResult(
                        messageData?.total_recipient,
                        messageData?.fail_message_count
                      )}%`}
                      styles={buildStyles({
                        textColor: '#3F4254',
                        pathColor: getColor(
                          calculateResult(
                            messageData?.total_recipient,
                            messageData?.fail_message_count
                          )
                        ),
                        trailColor: '#EEF6FF',
                      })}
                    />
                  </div>
                  <OverlayTrigger
                    placement='bottom'
                    overlay={<Tooltip>Message failed, expired and blocked</Tooltip>}
                  >
                    <div
                      className='title'
                      style={{
                        whiteSpace: 'nowrap',
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        marginTop: '12px',
                      }}
                    >
                      Failed
                      <div className='bottom'>
                        <div className='left'>({messageData?.fail_message_count})</div>
                      </div>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
            <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
              <div
                className='counted_box circle-progress'
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => navigate('/eofy/short_link')}
                data-testid='bmReportChartClickThrough'
              >
                <div
                  className='box'
                  style={{
                    gap: '0px',
                    marginTop: '10px',
                  }}
                >
                  <div style={{width: 100, height: 100}}>
                    <CircularProgressbar
                      value={calculateResult(
                        totalClickThrough(),
                        messageData?.tracking_link_click_count
                      )}
                      text={`${
                        calculateResult(
                          totalClickThrough(),
                          messageData?.tracking_link_click_count
                        ) || '0'
                      }%`}
                      styles={buildStyles({
                        textColor: '#3F4254',
                        pathColor: getColor(
                          calculateResult(
                            totalClickThrough(),
                            messageData?.tracking_link_click_count
                          )
                        ),
                        trailColor: '#EEF6FF',
                      })}
                    />
                  </div>
                  <OverlayTrigger
                    placement='bottom'
                    overlay={<Tooltip>Short url and landing page url clicks</Tooltip>}
                  >
                    <div
                      className='title'
                      style={{
                        whiteSpace: 'nowrap',
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        marginTop: '12px',
                      }}
                    >
                      Click through
                      <div className='bottom'>
                        <div className='left'>({messageData?.tracking_link_click_count || 0})</div>
                      </div>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
            <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
              <div
                className='counted_box circle-progress'
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => navigate('/eofy/customer_replies')}
                data-testid='bmReportChartCustomerReplies'
              >
                <div
                  className='box'
                  style={{
                    gap: '0px',
                    marginTop: '10px',
                  }}
                >
                  <div style={{width: 100, height: 100}}>
                    <CircularProgressbar
                      value={calculateResult(
                        messageData?.total_recipient,
                        messageData?.reply_count
                      )}
                      text={`${calculateResult(
                        messageData?.total_recipient,
                        messageData?.reply_count
                      )}%`}
                      styles={buildStyles({
                        textColor: '#3F4254',
                        pathColor: getColor(
                          calculateResult(messageData?.total_recipient, messageData?.reply_count)
                        ),
                        trailColor: '#EEF6FF',
                      })}
                    />
                  </div>
                  <OverlayTrigger
                    placement='bottom'
                    overlay={<Tooltip>Reply message from customer</Tooltip>}
                  >
                    <div
                      className='title'
                      style={{
                        whiteSpace: 'nowrap',
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        marginTop: '12px',
                      }}
                    >
                      Customer replies
                      <div className='bottom'>
                        <div className='left'>({messageData?.reply_count})</div>
                      </div>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>

            <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
              <div
                className='counted_box circle-progress'
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => {
                  calculateResult(messageData?.total_recipient, messageData?.unsubscribe_count) >
                    0 && navigate('/eofy/opt_out')
                }}
                data-testid='bmReportChartUnsubscribed'
              >
                <div
                  className='box'
                  style={{
                    gap: '0px',
                    marginTop: '10px',
                  }}
                >
                  <div style={{width: 100, height: 100}}>
                    <CircularProgressbar
                      value={calculateResult(
                        messageData?.total_recipient,
                        messageData?.unsubscribe_count
                      )}
                      text={`${calculateResult(
                        messageData?.total_recipient,
                        messageData?.unsubscribe_count
                      )}%`}
                      styles={buildStyles({
                        textColor: '#3F4254',
                        pathColor: getColor(
                          calculateResult(
                            messageData?.total_recipient,
                            messageData?.unsubscribe_count
                          )
                        ),
                        trailColor: '#EEF6FF',
                      })}
                    />
                  </div>
                  <OverlayTrigger
                    placement='bottom'
                    overlay={<Tooltip>The customer has responded to unsubscribe</Tooltip>}
                  >
                    <div
                      className='title'
                      style={{
                        whiteSpace: 'nowrap',
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        marginTop: '12px',
                      }}
                    >
                      Unsubscribed
                      <div className='bottom'>
                        <div className='left'>({messageData?.unsubscribe_count})</div>
                      </div>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-xl-4'>
              <div className='card p-8 py-5 h-100'>
                <div
                  className='mobile-bg-wrapper grey-bg new_mobile mb-0'
                  style={{
                    backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
                  }}
                >
                  <div className='mobile-inner'>
                    <div className='mobile-head'>
                      <strong
                        className='msg-mobile-title p-6 d-block text-center px-12'
                        data-testid='bmReportPreviewSenderId'
                      >
                        <KTSVG
                          className='svg-icon-8'
                          path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                        />
                        {messageData?.sender}
                      </strong>
                    </div>

                    <div className='mobile-body'>
                      <div className='message-box'>
                        <div className='time text-center'>
                          {moment(messageData?.createdAt).format('LT')}
                        </div>
                        {(messageData?.camp_type === 'mms' || messageData?.type === 'mms') && messageData?.subject && (
                          <div
                            className='message fw-bolder'
                            data-testid='bmReportPreviewMMSSubject'
                          >
                            {messageData?.subject || 'Engaging subject here'}
                          </div>
                        )}

                        {(messageData?.camp_type === 'mms' || messageData?.type === 'mms') &&
                          messageData?.media &&
                          Array.isArray(messageData?.media) &&
                          messageData?.media.length > 0 && (
                            <>
                              {typeof messageData?.media[0].url == 'string' && (
                                <span data-testid='bmReportPreviewMMSImage'>
                                  {!(messageData?.mediaType ?? messageData?.media[0].file)?.split('/')?.includes('video') &&
                                    !(messageData?.mediaType ?? messageData?.media[0].file)?.split('/')?.includes('vcard') && (
                                      <img
                                        src={
                                          messageData?.media[0].url ||
                                          'media/gif/default_mms_gif.gif'
                                        }
                                        alt=''
                                        className='rounded-3 mb-2'
                                      />
                                    )}

                                  {/* : (
                                  <video
                                    src={messageData?.media[0].url}
                                    width={300}
                                    height={100}
                                    controls
                                  />
                                ) */}
                                </span>
                              )}

                              {typeof messageData?.media[0].url !== 'string' && (
                                <span data-testid='bmReportPreviewMMSImage'>
                                  {!(messageData?.media[0].filetype ?? messageData?.media[0].file)?.split('/')?.includes('video') &&
                                    !messageData?.mediaType?.split('/')?.includes('vcard') && (
                                      <img
                                        src={URL.createObjectURL(messageData?.media[0].url)}
                                        alt=''
                                        className='rounded-3 mb-2'
                                      />
                                    )}

                                  {/* : (
                                  <video
                                    src={URL.createObjectURL(messageData?.media[0].url)}
                                    width={300}
                                    height={100}
                                    controls
                                  />
                                ) */}
                                </span>
                              )}

                              {typeof messageData?.media[0].url === 'string' && (
                                <span data-testid='bmReportPreviewMMSVideo'>
                                  {['mp4', 'mov', 'webm', 'ogg'].includes(messageData?.media[0].filetype || messageData?.media[0].file) && (
                                     <video
                                      src={URL.createObjectURL(messageData?.media[0].url)}
                                      width={300}
                                      height={100}
                                      controls
                                    />
                                  )}
                                </span>
                              )}

                              {typeof messageData?.media[0].url === 'string' && (
                                <span data-testid='bmReportPreviewMMSVCard'>
                                  {(messageData?.media[0].filetype || messageData?.media[0].file)
                                    ?.split('/')
                                    ?.includes('vcard') && (
                                    <VCardPreview vcfUrl={messageData?.media[0].url} />
                                  )}
                                </span>
                              )}
                            </>
                          )}

                        <div className='message'>
                          <pre data-testid='bmReportPreviewMessage'>
                            {messageData?.message}
                            {messageData?.is_reply_stop_out && "\n\nReply 'STOP' to opt-out"}
                          </pre>
                        </div>
                      </div>
                      <div className='send-msg'>
                        <input type='text' />
                        <a
                          href='#'
                          className='send_btn'
                          style={{
                            backgroundImage: `url(${toAbsoluteUrl('/media/mobile/send.svg')})`,
                          }}
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-xl-8'>
              <div className='card p-8 py-5'>
                <div className='card-header border-0 p-0 min-h-50'>
                  <h3 className='card-title align-items-start'>
                    <span className='card-label fw-bolder fs-2 mb-1'>Campaign Overview</span>
                  </h3>
                </div>
                <div className='card-body px-0 pt-1'>
                  <div className='analytics_charts bounce_chart' data-testid='bmReportPreviewChart'>
                    <div className='chart_body'>
                      <ReactApexChart
                        options={bouncedDataRegion.options}
                        series={bouncedDataRegion.series}
                        type='donut'
                        width={450}
                      />
                    </div>
                    <div className='box_container'>
                      <OverlayTrigger
                        placement='top'
                        overlay={<Tooltip>Message failed, expired and blocked</Tooltip>}
                      >
                        <div className='item'>
                          <span
                            className='dot'
                            style={{
                              background: ' rgb(0, 143, 251) ',
                            }}
                          ></span>
                          {`Failed      ${
                            messageData?.fail_message_count
                          } (${+messageData?.fail_message_count?.toFixed(2)}%)`}
                        </div>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement='top'
                        overlay={<Tooltip>Message delivered to customers mobile</Tooltip>}
                      >
                        <div className='item'>
                          <span
                            className='dot'
                            style={{
                              background: ' rgb(0, 227, 150) ',
                            }}
                          ></span>
                          {`Delivered      ${+messageData?.delivered_message_count} (${+messageData?.delivered_message_count?.toFixed(
                            2
                          )}%)`}
                        </div>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement='top'
                        overlay={<Tooltip>Message not delivered to customers mobile</Tooltip>}
                      >
                        <div className='item'>
                          <span
                            className='dot'
                            style={{
                              background: ' rgb(254, 176, 25) ',
                            }}
                          ></span>
                          {`Not sent  ${
                            +messageData?.total_recipient -
                            +messageData?.fail_message_count -
                            +messageData?.delivered_message_count
                          } (${+(
                            100 -
                            sendData -
                            (+messageData?.fail_message_count * 100) / +messageData?.total_recipient
                          )?.toFixed(2)}%)`}
                        </div>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </>
    )
  }

  const renderDefaultRegion = () => {
    return (
      <>
        <div className='counted_box_wrapper row'>
          <div className='col-xl-2 col-md-3 col-sm-4 col-6 '>
            <div
              className='counted_box circle-progress'
              style={{
                cursor: 'pointer',
              }}
              onClick={() => navigate('/eofy/contacts')}
              data-testid='bmReportChartContacts'
            >
              <div
                className='box'
                style={{
                  gap: '0px',
                  marginTop: '10px',
                }}
              >
                <div style={{width: 100, height: 100}}>
                  <CircularProgressbar
                    value={calculateResult(
                      messageData?.staggerId && messageData?.totalRecipients
                        ? messageData?.totalRecipients
                        : messageData?.recipients,
                      messageData?.recipients
                    )}
                    text={`${calculateResult(
                      messageData?.staggerId && messageData?.totalRecipients
                        ? messageData?.totalRecipients
                        : messageData?.recipients,
                      messageData?.recipients
                    )}%`}
                    styles={buildStyles({
                      textColor: '#3F4254',
                      pathColor: getColor(
                        calculateResult(
                          messageData?.staggerId && messageData?.totalRecipients
                            ? messageData?.totalRecipients
                            : messageData?.recipients,
                          messageData?.recipients
                        )
                      ),
                      trailColor: '#EEF6FF',
                    })}
                  />
                </div>

                <div
                  className='title'
                  style={{
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    marginTop: '12px',
                  }}
                >
                  Contacts
                  <div className='bottom'>
                    <div className='left'>
                      ({' '}
                      {messageData?.staggerId && messageData?.completedRecipients
                        ? `${messageData?.completedRecipients}/${messageData?.totalRecipients}`
                        : messageData?.recipients}
                      )
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
            <div
              className='counted_box circle-progress'
              style={{
                cursor: 'pointer',
              }}
              onClick={() => navigate('/eofy/contacts')}
              data-testid='bmReportChartDelivered'
            >
              <div
                className='box'
                style={{
                  gap: '0px',
                  marginTop: '10px',
                }}
              >
                <div style={{width: 100, height: 100}}>
                  <CircularProgressbar
                    value={calculateResult(
                      messageData?.staggerId && messageData?.totalRecipients
                        ? messageData?.totalRecipients
                        : messageData?.recipients,
                      deliveredData
                    )}
                    text={`${calculateResult(
                      messageData?.staggerId && messageData?.totalRecipients
                        ? messageData?.totalRecipients
                        : messageData?.recipients,
                      deliveredData
                    )}%`}
                    styles={buildStyles({
                      textColor: '#3F4254',
                      pathColor: getColor(
                        calculateResult(
                          messageData?.staggerId && messageData?.totalRecipients
                            ? messageData?.totalRecipients
                            : messageData?.recipients,
                          deliveredData
                        )
                      ),
                      trailColor: '#EEF6FF',
                    })}
                  />
                </div>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip>Message delivered to customers mobile</Tooltip>}
                >
                  <div
                    className='title'
                    style={{
                      whiteSpace: 'nowrap',
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                      marginTop: '12px',
                    }}
                  >
                    Delivered
                    <div className='bottom'>
                      <div className='left'>({deliveredData})</div>
                    </div>
                  </div>
                </OverlayTrigger>
              </div>
            </div>
          </div>
          <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
            <div
              className='counted_box circle-progress'
              style={{
                cursor: 'pointer',
              }}
              onClick={() => navigate('/eofy/bounced')}
              data-testid='bmReportChartFailed'
            >
              <div
                className='box'
                style={{
                  gap: '0px',
                  marginTop: '10px',
                }}
              >
                <div style={{width: 100, height: 100}}>
                  <CircularProgressbar
                    value={calculateResult(messageData?.recipients, messageData?.bouncedMessage)}
                    text={`${calculateResult(
                      messageData?.recipients,
                      messageData?.bouncedMessage
                    )}%`}
                    styles={buildStyles({
                      textColor: '#3F4254',
                      pathColor: getColor(
                        calculateResult(messageData?.recipients, messageData?.bouncedMessage)
                      ),
                      trailColor: '#EEF6FF',
                    })}
                  />
                </div>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip>Message failed, expired and blocked</Tooltip>}
                >
                  <div
                    className='title'
                    style={{
                      whiteSpace: 'nowrap',
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                      marginTop: '12px',
                    }}
                  >
                    Failed
                    <div className='bottom'>
                      <div className='left'>({messageData?.bouncedMessage})</div>
                    </div>
                  </div>
                </OverlayTrigger>
              </div>
            </div>
          </div>
          <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
            <div
              className='counted_box circle-progress'
              style={{
                cursor: 'pointer',
              }}
              onClick={() => navigate('/eofy/short_link')}
              data-testid='bmReportChartClickThrough'
            >
              <div
                className='box'
                style={{
                  gap: '0px',
                  marginTop: '10px',
                }}
              >
                <div style={{width: 100, height: 100}}>
                  <CircularProgressbar
                    value={calculateResult(totalClickThrough(), messageData?.clickThrough)}
                    text={`${
                      calculateResult(totalClickThrough(), messageData?.clickThrough) || '0'
                    }%`}
                    styles={buildStyles({
                      textColor: '#3F4254',
                      pathColor: getColor(
                        calculateResult(totalClickThrough(), messageData?.clickThrough)
                      ),
                      trailColor: '#EEF6FF',
                    })}
                  />
                </div>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip>Short url and landing page url clicks</Tooltip>}
                >
                  <div
                    className='title'
                    style={{
                      whiteSpace: 'nowrap',
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                      marginTop: '12px',
                    }}
                  >
                    Click through
                    <div className='bottom'>
                      <div className='left'>({messageData?.clickThrough})</div>
                    </div>
                  </div>
                </OverlayTrigger>
              </div>
            </div>
          </div>
          <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
            <div
              className='counted_box circle-progress'
              style={{
                cursor: 'pointer',
              }}
              onClick={() => navigate('/eofy/customer_replies')}
              data-testid='bmReportChartCustomerReplies'
            >
              <div
                className='box'
                style={{
                  gap: '0px',
                  marginTop: '10px',
                }}
              >
                <div style={{width: 100, height: 100}}>
                  <CircularProgressbar
                    value={calculateResult(messageData?.recipients, messageData?.replies)}
                    text={`${calculateResult(messageData?.recipients, messageData?.replies)}%`}
                    styles={buildStyles({
                      textColor: '#3F4254',
                      pathColor: getColor(
                        calculateResult(messageData?.recipients, messageData?.replies)
                      ),
                      trailColor: '#EEF6FF',
                    })}
                  />
                </div>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip>Reply message from customer</Tooltip>}
                >
                  <div
                    className='title'
                    style={{
                      whiteSpace: 'nowrap',
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                      marginTop: '12px',
                    }}
                  >
                    Customer replies
                    <div className='bottom'>
                      <div className='left'>({messageData?.replies})</div>
                    </div>
                  </div>
                </OverlayTrigger>
              </div>
            </div>
          </div>

          <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
            <div
              className='counted_box circle-progress'
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                calculateResult(messageData?.recipients, getUnsubscribeCount(messageData)) > 0 &&
                  navigate('/eofy/opt_out')
              }}
              data-testid='bmReportChartUnsubscribed'
            >
              <div
                className='box'
                style={{
                  gap: '0px',
                  marginTop: '10px',
                }}
              >
                <div style={{width: 100, height: 100}}>
                  <CircularProgressbar
                    value={calculateResult(messageData?.recipients,  getUnsubscribeCount(messageData))}
                    text={`${calculateResult(messageData?.recipients,  getUnsubscribeCount(messageData))}%`}
                    styles={buildStyles({
                      textColor: '#3F4254',
                      pathColor: getColor(
                        calculateResult(messageData?.recipients,  getUnsubscribeCount(messageData))
                      ),
                      trailColor: '#EEF6FF',
                    })}
                  />
                </div>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip>The customer has responded to unsubscribe</Tooltip>}
                >
                  <div
                    className='title'
                    style={{
                      whiteSpace: 'nowrap',
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                      marginTop: '12px',
                    }}
                  >
                    Unsubscribed
                    <div className='bottom'>
                      <div className='left'>({ getUnsubscribeCount(messageData)})</div>
                    </div>
                  </div>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-xl-4'>
            <div className='card p-8 py-5 h-100'>
              <div
                className='mobile-bg-wrapper grey-bg new_mobile mb-0'
                style={{
                  backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
                }}
              >
                <div className='mobile-inner'>
                  <div className='mobile-head'>
                    <strong
                      className='msg-mobile-title p-6 d-block text-center px-12'
                      data-testid='bmReportPreviewSenderId'
                    >
                      <KTSVG
                        className='svg-icon-8'
                        path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                      />
                      {messageData?.sender}
                    </strong>
                  </div>

                  <div className='mobile-body'>
                    <div className='message-box'>
                      <div className='time text-center'>
                        Hello {moment(messageData?.createdAt).format('LT')}
                      </div>
                      {messageData?.camp_type === 'mms' && messageData?.subject && (
                        <div className='message fw-bolder' data-testid='bmReportPreviewMMSSubject'>
                          {messageData?.subject || 'Engaging subject here'}
                        </div>
                      )}
                    
                      {messageData?.camp_type === 'mms' &&
                        messageData?.media &&
                        Array.isArray(messageData?.media) &&
                        messageData?.media.length > 0 && (
                          <>
                            {typeof messageData?.media[0].url == 'string' && (
                              <span data-testid='bmReportPreviewMMSImage'>
                                {!messageData?.mediaType?.split('/')?.includes('video') &&
                                  !messageData?.mediaType?.split('/')?.includes('vcard') && (
                                    <img
                                      src={
                                        messageData?.media[0].url || 'media/gif/default_mms_gif.gif'
                                      }
                                      alt=''
                                      className='rounded-3 mb-2'
                                    />
                                  )}

                                {/* : (
                                  <video
                                    src={messageData?.media[0].url}
                                    width={300}
                                    height={100}
                                    controls
                                  />
                                ) */}
                              </span>
                            )}
            
                            {typeof messageData?.media[0].url !== 'string' && (
                              <span data-testid='bmReportPreviewMMSImage'>
                                {!messageData?.media[0].filetype?.split('/')?.includes('video') &&
                                  !messageData?.mediaType?.split('/')?.includes('vcard') && (
                                    <img
                                      src={URL.createObjectURL(messageData?.media[0].url)}
                                      alt=''
                                      className='rounded-3 mb-2'
                                    />
                                  )}

                                {/* : (
                                  <video
                                    src={URL.createObjectURL(messageData?.media[0].url)}
                                    width={300}
                                    height={100}
                                    controls
                                  />
                                ) */}
                              </span>
                            )}

                            {messageData?.media[0].url && (
                              <span data-testid='bmReportPreviewMMSVideo'>
                                {messageData?.media[0]?.filetype?.split('/')?.includes('video') && (
                                    <video
                                      src={messageData?.media[0].url}
                                      width={'100%'}
                                      height={'auto'}
                                      controls
                                    />
                                  )}
                              </span>
                            )}

                            {typeof messageData?.media[0].url === 'string' && (
                              <span data-testid='bmReportPreviewMMSVCard'>
                                {messageData?.media[0].filetype?.split('/')?.includes('vcard') && (
                                  <VCardPreview vcfUrl={messageData?.media[0].url} />
                                )}
                              </span>
                            )}
                          </>
                        )}

                      <div className='message'>
                        <pre data-testid='bmReportPreviewMessage'>{messageData?.message}</pre>
                      </div>
                    </div>
                    <div className='send-msg'>
                      <input type='text' />
                      <a
                        href='#'
                        className='send_btn'
                        style={{
                          backgroundImage: `url(${toAbsoluteUrl('/media/mobile/send.svg')})`,
                        }}
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-xl-8'>
            <div className='card p-8 py-5'>
              <div className='card-header border-0 p-0 min-h-50'>
                <h3 className='card-title align-items-start'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Campaign Overview</span>
                </h3>
              </div>
              <div className='card-body px-0 pt-1'>
                <div className='analytics_charts bounce_chart' data-testid='bmReportPreviewChart'>
                  <div className='chart_body'>
                    <ReactApexChart
                      options={bouncedData.options}
                      series={bouncedData.series}
                      type='donut'
                      width={450}
                    />
                  </div>
                  <div className='box_container'>
                    <OverlayTrigger
                      placement='top'
                      overlay={<Tooltip>Message failed, expired and blocked</Tooltip>}
                    >
                      <div className='item'>
                        <span
                          className='dot'
                          style={{
                            background: ' rgb(0, 143, 251) ',
                          }}
                        ></span>
                        {`Failed      ${messageData?.bouncedMessage} (${+bouncedPer?.toFixed(2)}%)`}
                      </div>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement='top'
                      overlay={<Tooltip>Message delivered to customers mobile</Tooltip>}
                    >
                      <div className='item'>
                        <span
                          className='dot'
                          style={{
                            background: ' rgb(0, 227, 150) ',
                          }}
                        ></span>
                        {`Delivered      ${+deliveredData} (${+sendData?.toFixed(2)}%)`}
                      </div>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement='top'
                      overlay={<Tooltip>Message not delivered to customers mobile</Tooltip>}
                    >
                      <div className='item'>
                        <span
                          className='dot'
                          style={{
                            background: ' rgb(254, 176, 25) ',
                          }}
                        ></span>
                        {`Not sent  ${
                          +messageData?.recipients - +messageData?.bouncedMessage - +deliveredData
                        } (${+(
                          100 -
                          sendData -
                          (+messageData?.bouncedMessage * 100) / +messageData?.recipients
                        )?.toFixed(2)}%)`}
                      </div>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  return <>{isDefaultRegion ? renderDefaultRegion() : renderRegionData()}</>
}

export default Snapshot
